import React from 'react';
import '../../styles/test-system.css';
import Countdown from './Countdown';
import { formatInTimeZone, getTimeZoneLabel } from '../../utils/dateUtils';

/**
 * What a candidate has to know before the confirmation window shuts on them:
 * the moment it shuts, on the cohort's own clock, and what it costs to miss it.
 *
 * A scheduled cohort closes the window at its start, so there is a moment to name
 * and a countdown to run against. A manual-start cohort has no scheduled close at
 * all — enrolment was cut off when the window opened and the team closes it by
 * starting the cycle (admin-portal-backend `_close_the_open_window`) — so naming a
 * time would be inventing one. It is told plainly instead.
 *
 * @param {Object} props
 * @param {Object} props.cycle - Projected cycle
 */
const ConfirmationDeadline = ({ cycle }) => {
    const timeZone = cycle?.display_timezone;
    const closesAt = cycle?.start_at;

    return (
        <p className="ts-note ts-note--warn" data-testid="confirmation-deadline">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span>
                {closesAt ? (
                    <>
                        Confirm by{' '}
                        <strong>
                            {formatInTimeZone(closesAt, timeZone)} {getTimeZoneLabel(closesAt, timeZone)}
                        </strong>
                        {' '}(<Countdown target={closesAt} passedLabel="the window has closed" />) — that
                        is when the cycle starts.
                    </>
                ) : (
                    <>Confirm now. The team closes this window when they start the cycle, and
                    we will email you when that happens.</>
                )}
                {' '}A spot that is not confirmed is given up, and the entry goes back to
                your balance.
            </span>
        </p>
    );
};

export default ConfirmationDeadline;
